import type { Organizer } from '@/types';
import styles from './AvatarComponent.module.scss';
import { VerifiedIcon } from '../../VerifiedIcon/VerifiedIcon';
import { CrownIcon } from '@/components/_shared/Icons';
import { UserIcon } from '../../UserIcon/UserIcon';
import { Avatar } from '@eventbrite/marmalade';
import { getImageProps } from 'next/image';
import { useFeatureFlags } from '@/components/_shared/contexts/FeatureFlagsContext';

export interface AvatarComponentProps {
  organizer: Organizer;
  clickable?: boolean;
  onClick?: () => void;
  size?: 'small' | 'large';
}

export const AvatarComponent: React.FC<AvatarComponentProps> = ({
  organizer,
  clickable = false,
  onClick,
  size = 'large',
}) => {
  const avatarText = (organizer.name && organizer.name[0]) || '';
  const featureFlags = useFeatureFlags();

  const className = `${styles.avatarWithBadge} ${clickable ? styles.clickable : ''} ${styles[size]}`.trim();

  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 52,
    height: 58,
    src: organizer.image || '',
  });

  const isSuperOrganizer = featureFlags.topOrganizerListingPage && organizer.superOrganizer === true;
  const BadgeIcon = isSuperOrganizer ? CrownIcon : VerifiedIcon;
  const showBadge = isSuperOrganizer || organizer.verified;

  return (
    <div className={className} onClick={() => clickable && onClick && onClick()}>
      <Avatar
        className={styles.customAvatar}
        text={avatarText}
        icon={<UserIcon />}
        imageSrc={src}
        imageAlt={organizer.name}
        placeholder={organizer.name}
      ></Avatar>
      {showBadge && (
        <div className={styles.verifiedBadge}>
          <BadgeIcon />
        </div>
      )}
    </div>
  );
};
